import { TADARAB_FOR_BUSINESS_SAFETY_AND_TERMS } from "../../constants/landingPage";

const SafetyAndTermsItem = ({ Icon, title, subTitle, link }) => (
  <div className="safety__item">
    <div className="safety__item-icon">
      <Icon className="safety__icon" />
    </div>
    <div className="safety__item-content">
      <div className="safety__item-text">
        <p className="safety__item-title">{title}</p>
        <p className="safety__item-subtitle">{subTitle}</p>
      </div>
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className="safety__item-btn"
      >
        إقرأ المزيد
      </a>
    </div>
  </div>
);

const SafetyAndTerms = () => (
  <div className="safety">
    <p className="safety__heading">الأمان والشروط</p>
    <div className="safety__list">
      {TADARAB_FOR_BUSINESS_SAFETY_AND_TERMS.map(({ id, Icon, title, subTitle, link }) => (
        <SafetyAndTermsItem
          key={id}
          Icon={Icon}
          title={title}
          subTitle={subTitle}
          link={link}
        />
      ))}
    </div>
  </div>
);

export default SafetyAndTerms;
